
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from '@/lib/Question';

    @Component({})
    export default class CustomValuableThingsQuestion extends Vue {
        @Prop() public question: Question;
        public optionId?: number = 0;
        public singleValue: number = 300000;
        public increase(){
            let value =  parseInt(this.question.currentResponse!.value) + 300000;
            this.question.currentResponse!.value = value+'';
            this.updateResponse();
        }
        public decrease(){

            let value =  parseInt(this.question.currentResponse!.value) - 300000;
            if (value < 0) {
                value = 0;
            }
            this.question.currentResponse!.value = value+'';
            this.updateResponse();
        }

        mounted() {
            if (!this.question.currentResponse!.value) {
                this.question.currentResponse!.value = '0';
            }
        }


        public updateResponse(
        ){
            this.question.validate();
            this.question.changedEvent.emit('changed');
            console.log(this.question);
        }

    }
